import { PayloadAction } from '@reduxjs/toolkit'

import { AnyAction } from 'redux'

import { getLocations } from './shopThunks'

export const isPendingShopAction = (action: AnyAction): action is PayloadAction<never> => {
  return [getLocations.pending.type].includes(action.type)
}

export const isRejectedShopAction = (action: AnyAction): action is PayloadAction<never> => {
  return [getLocations.rejected.type].includes(action.type)
}
